import CarouselFigure from 'bee-carousel-figure'
export default CarouselFigure
